module.exports = __webpack_public_path__ + "static/image/logo-family/new_logo_thrifty.ver2_0_2.png?3a932921";